import { OPEN_MODAL, CLOSE_MODAL } from "./types";


export const openModal = (modalName) => {
    return {
        type: OPEN_MODAL,
        payload: modalName
    }
}

export const closeModal = () => {
    return {
        type: CLOSE_MODAL,
    }
}